import { api } from "@/axios";
import responseHandler from "@/responseHandler.js";
//import { userSetter } from "core-js/fn/symbol";

const state = {
  users: [],
};

const getters = {
  getUsers: (state) => state.users,
  getUserById: (state) => (id) => state.users.find((x) => x.id == id),
};

const actions = {
  async fetchUsers({ commit }) {
    try {
      const resp = await api.get("/users");
      if (resp.status == 200) {
        const users = resp.data.data.users;
        commit("setUsers", users);
      }
    } catch (error) {
      return false;
    }
  },
  async updateUser({ commit }, user) {
    try {
      const id = user.id;
      user._method = "patch";

      const resp = await api.post(`/users/${id}`, user);
      if (resp.status == 200) {
        const user = resp.data.data;
        commit("updateUser", user);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
  async addUser({ commit }, user) {
    try {
      const resp = await api.post(`/users`, user);

      if (resp.status == 201) {
        const user = resp.data.data;

        commit("addUser", user);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
  async deleteUser({ commit }, id) {
    try {
      const resp = await api.delete(`/users/${id}`);

      if (resp.status == 204) {
        commit("deleteUser", id);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
};

const mutations = {
  setUsers(state, users) {
    state.users = users;
  },
  updateUser(state, user) {
    const id = user.id;
    const index = state.users.findIndex((user) => user.id == id);
    if (index !== -1) {
      state.users[index] = user;
    }
  },
  addUser(state, user) {
    state.users.unshift(user);
    console.log("users", state.users);
    console.log("user", user);
  },

  deleteUser(state, id) {
    const index = state.users.findIndex((p) => p.id == id);
    if (index !== -1) {
      state.users.splice(index, 1);
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
